import { ViewModel, View, ObservableArray } from "binder"
import moment from "moment";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ISendPackageTab } from "../sendPackageDetail/sendPackageDetail-viewModel";
import { SendPackageRequestsView } from "./sendPackageRequests-view"

export class SendPackageRequestsViewModel extends ViewModel implements ISendPackageTab {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.tabName = 'درخواست ها';
        this.sendPackageSendables = ObservableArray.create<SendPackageSendable>();
    }
    GetDefaultView(): View<ViewModel> {
        return new SendPackageRequestsView();
    }
    public getTypeId(): string {
        return "VM-05BBF54C-36AC-441B-B929-488733B7F268"
    }
    public set tabName(v: string) { this._tabName = v; } public get tabName(): string { return this._tabName; } private _tabName: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set sendPackageSendables(v: ObservableArray<SendPackageSendable>) { this._sendPackageSendables = v; } public get sendPackageSendables(): ObservableArray<SendPackageSendable> { return this._sendPackageSendables; } private _sendPackageSendables: ObservableArray<SendPackageSendable>;
    public set sendPackageId(v: string) { this._sendPackageId = v; } public get sendPackageId(): string { return this._sendPackageId;} private _sendPackageId: string;

    public async load(sendPackageId) {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllSendPackageRequests', {
                SendPackageId: sendPackageId,
            });
            if (!result.IsSuccessful) {
                throw 'New Error';
            }
            this.sendPackageId = sendPackageId;
            this.sendPackageSendables.update(...result.SendPackages.map((q, i) => {
                let r = new SendPackageSendable(this);
                r.rowNumber = i + 1;
                r.creationTime = moment.utc(q.CreatedTime);
                r.sendableId = q.SendableId;
                r.invoiceNumber = q.InvoiceNumber;
                r.hasInvoice = stringIsNullOrEmpty(q.InvoiceNumber) ? false : true;
                r.sendableType = r.hasInvoice ? "فاکتور" : "درخواست بهینه";
                r.canRemove = q.State === 0;
                r.toWarehouseId = q.ToWarehouseId;
                r.toWarehouseName = q.ToWarehouseName;
                r.fromWarehouseId = q.FromWarehouseId;
                r.fromWarehouseName = q.FromWarehouseName;
                r.products.update(...q.Products.map(p => {
                    let f = new SendPackageLineItem(this);
                    f.measuredProductId = p.MeasuredProductId;
                    f.productCode = p.ProductCode;
                    f.productName = p.ProductName;
                    f.productCarModel = p.ProductCarModel;
                    f.amount = p.Amount;
                    r.balance += f.amount;
                    f.requesterName = q.CreatorName;
                    return f;
                }));
                r.productInfo = r.products.map(q => {
                    return q.productCode
                }).join('\n');
                return r;
            }))
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex, "خطا")
        } finally {
            this.isLoading = false;
        }
    }

}

export class SendPackageSendable extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: SendPackageRequestsViewModel) {
        super(parent);
        this._typedParent = parent;
        this.balance = 0;
        this.products = ObservableArray.create<SendPackageLineItem>();
    }

    private _typedParent: SendPackageRequestsViewModel;

    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set sendableId(v: string) { this._sendableId = v; } public get sendableId(): string { return this._sendableId; } private _sendableId: string;
    public set sendableType(v: string) { this._sendableType = v; } public get sendableType(): string { return this._sendableType; } private _sendableType: string;
    public set fromWarehouseId(v: string) { this._fromWarehouseId = v; } public get fromWarehouseId(): string { return this._fromWarehouseId; } private _fromWarehouseId: string;
    public set fromWarehouseName(v: string) { this._fromWarehouseName = v; } public get fromWarehouseName(): string { return this._fromWarehouseName; } private _fromWarehouseName: string;
    public set toWarehouseId(v: string) { this._toWarehouseId = v; } public get toWarehouseId(): string { return this._toWarehouseId; } private _toWarehouseId: string;
    public set toWarehouseName(v: string) { this._toWarehouseName = v; } public get toWarehouseName(): string { return this._toWarehouseName; } private _toWarehouseName: string;
    public set collectNumber(v: string) { this._collectNumber = v; } public get collectNumber(): string { return this._collectNumber; } private _collectNumber: string;
    public set sendPackageState(v: number) { this._sendPackageState = v; } public get sendPackageState(): number { return this._sendPackageState; } private _sendPackageState: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set creatorName(v: string) { this._creatorName = v; } public get creatorName(): string { return this._creatorName; } private _creatorName: string;
    public set invoiceNumber(v: string) { this._invoiceNumber = v; } public get invoiceNumber(): string { return this._invoiceNumber; } private _invoiceNumber: string;
    public set products(v: ObservableArray<SendPackageLineItem>) { this._products = v; } public get products(): ObservableArray<SendPackageLineItem> { return this._products; } private _products: ObservableArray<SendPackageLineItem>;
    public set balance(v: number) { this._balance = v; } public get balance(): number { return this._balance; } private _balance: number;
    public set hasInvoice(v: boolean) { this._hasInvoice = v; } public get hasInvoice(): boolean { return this._hasInvoice; } private _hasInvoice: boolean;
    public set productInfo(v: string) { this._productInfo = v; } public get productInfo(): string { return this._productInfo; } private _productInfo: string;
    public set warehouseLocation(v: string) { this._warehouseLocation = v; } public get warehouseLocation(): string { return this._warehouseLocation; } private _warehouseLocation: string;
    public set canRemove(v: boolean) { this._canRemove = v; } public get canRemove(): boolean { return this._canRemove;} private _canRemove: boolean;

    async getWarehouseBalanceInfo() {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetWarehouseBalanceByProductIds', {
            MeasuredProductIds: this.products.map(q => {
                return { 
                    WarehouseId: this.fromWarehouseId,
                    MeasuredProductId: q.measuredProductId 
                }
            })
        });
        if (result.IsSuccessful == false) {
            throw "new Error";
        }
        result.WarehouseBalances.map(p => {
            let f = this.products.find(x => x.measuredProductId === p.MeasuredProductId);
            f.warehouseLocation = p.WarehouseLocation;
            f.stockBalance = p.StockBalance;
            f.availableBalance = p.AccessibleBalance;
            f.inSellProcess = f.stockBalance - f.availableBalance
        });
    }
    async remove() {
        try {
            let confirmation ='';
            confirmation = await this.messageBoxWarningYesNo('آیا این کالا از بسته حذف شود؟','حذف آیتم از بسته');
            if(confirmation=='no'){
                return;
            }
            this._typedParent.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/RemoveSendPackageItem', {
                SendableId: this.sendableId,
                SendPackageId: this._typedParent.sendPackageId
            });
            if (result.IsSuccessful == false) {
                throw "new Error";
            }
            if (result.Removed == true) {
                await this.messageBoxConfirmSuccess('آیتم ها از بسته با موفقیت حذف شدند.', 'عملیات موفق');
                this._typedParent.load(this._typedParent.sendPackageId);
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex, "خطا")
        } finally {
            this._typedParent.isLoading = false;
        }
    }
}

export class SendPackageLineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.typedParent = parent;
    }

    private typedParent: ViewModel;
    public set measuredProductId(v: string) { this._measuredProductId = v; } public get measuredProductId(): string { return this._measuredProductId; } private _measuredProductId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set stockBalance(v: number) { this._stockBalance = v; } public get stockBalance(): number { return this._stockBalance; } private _stockBalance: number;
    public set availableBalance(v: number) { this._availableBalance = v; } public get availableBalance(): number { return this._availableBalance; } private _availableBalance: number;
    public set inSellProcess(v: number) { this._inSellProcess = v; } public get inSellProcess(): number { return this._inSellProcess; } private _inSellProcess: number;
    public set warehouseLocation(v: string) { this._warehouseLocation = v; } public get warehouseLocation(): string { return this._warehouseLocation; } private _warehouseLocation: string;
    public set requesterName(v: string) { this._requesterName = v; } public get requesterName(): string { return this._requesterName;} private _requesterName: string;
    
}